module.exports = __webpack_public_path__ + "img/lit_wp.2c5039b8.png";